import { Spin } from "antd";
import * as React from "react";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import { IOrganisationIndexCategoryPresenter } from "../../presenter/OrganisationIndexCategoryPresenter";
import OrganisationIndexCategoryGrid from "../components/OrganisationIndexCategoryGrid";

export interface Props extends PageProps {}
export interface State extends IOrganisationIndexCategoryPresenter {}

export default class OrganisationCategoryPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      organisationIndexCategories,
      organisationId,
      indexTypeCategories,
      createCategory,
      updateOrganisationIndexCategory,
      showOrganisationIndexDetails,
      createOrganisationCategoryModalVisible,
      indexTypeCategoryId,
      changeCreateCategoryModalVisible,
      store
    } = this.state;
    return (
      <Page {...this.props} className={"content-wrapper"}>
        <Spin spinning={this.state.loaders.organisationIndexCategoriesLoader}>
          <OrganisationIndexCategoryGrid
            createOrganisationCategoryModalVisible={
              createOrganisationCategoryModalVisible
            }
            indexTypeCategoryId={indexTypeCategoryId}
            showDetails={showOrganisationIndexDetails}
            changeCreateCategoryModalVisible={changeCreateCategoryModalVisible}
            translate={translate}
            organisationIndexCategories={organisationIndexCategories}
            organisationId={organisationId}
            indexTypeCategories={indexTypeCategories}
            createCategory={createCategory}
            updateOrganisationIndexCategory={updateOrganisationIndexCategory}
            loader={this.state.loaders.organisationIndexCategoriesLoader}
            store={store}
          />
        </Spin>
      </Page>
    );
  }
}
